import { useEffect, useState } from "react";
import {    useNavigate} from "react-router-dom";    
import wmsRecurringScheduleService
    from "../../services/wmsRecurringScheduleService";

import RecurringScheduleTable
    from "../components/RecurringScheduleTable";

import RecurringScheduleFilter
    from "../components/RecurringScheduleFilter";


function RecurringScheduleListPage() {

    const [loading, setLoading] =
        useState(false);

    const [rows, setRows] =
        useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0,
        per_page: 20
    });

    const navigate =     useNavigate();    

    const [filters, setFilters] =
        useState({

            search: "",

            work_mode: "",

            frequency: "",

            status: ""

        });

    // ==========================================================
    // FILTER CHANGE
    // ==========================================================

    function handleFilterChange(
        field,
        value
    ) {

        setFilters(prev => ({

            ...prev,

            [field]: value

        }));

    }

    // ==========================================================
    // RESET FILTERS
    // ==========================================================

    function handleReset() {

        const resetFilters = {

            search: "",

            work_mode: "",

            frequency: "",

            status: ""

        };

        setFilters(
            resetFilters
        );

        loadSchedules(
            resetFilters
        );

    }

    async function handleRunScheduler() {

    try {

        setLoading(true);

        const result =
            await wmsRecurringScheduleService.runScheduler();

        alert(

`Scheduler Completed

Schedules Processed : ${result.total}

Successful          : ${result.success}

Failed              : ${result.failed}`

        );

        await loadSchedules();

    }

    catch (err) {

        console.error(err);

        alert(
            "Failed to execute scheduler."
        );

    }

    finally {

        setLoading(false);

    }

}
    // ==========================================================
    // LOAD SCHEDULES
    // ==========================================================

    async function loadSchedules(
        filterValues = filters,
        page = 1
    ) {

        try {

            setLoading(true);

            const result =
                await wmsRecurringScheduleService.getSchedules({

                    search:
                        filterValues.search,

                    work_mode:
                        filterValues.work_mode,

                    frequency:
                        filterValues.frequency,

                    status:
                        filterValues.status,

                        page:
                            page,

                        per_page:
                            20
                });

            console.log(
                "Recurring Schedules",
                result
            );

            setRows(
                result.data || []
            );
            console.log(
                "Pagination State",
                result.pagination
            );
            setPagination(
                result.pagination || {
                    page: 1,
                    pages: 1,
                    total: 0,
                    per_page: 20
                }
            );
            console.log(
                "Pagination After Set",
                result.pagination
            );
            // Future
            // setPagination(result.pagination);

        }

        catch (err) {

            console.error(err);

        }

        finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        loadSchedules();

    }, []);

    // ==========================================================
    // TABLE ACTIONS
    // ==========================================================

    function handleView(
    row
) {

    navigate(
        `/wms/recurring-schedules/${row.id}`
    );

}

    function handleEdit(
        row
    ) {

        console.log(
            "Edit",
            row
        );

    }

    async function handlePause(
    row
) {

    if (
        !window.confirm(
            `Pause schedule "${row.schedule_name}"?`
        )
    ) {

        return;

    }

    try {

        await wmsRecurringScheduleService.pauseSchedule(
            row.id
        );

        alert(
            "Schedule paused successfully."
        );

        loadSchedules();

    }

    catch (err) {

        console.error(err);

        alert(
            "Failed to pause schedule."
        );

    }

}

    async function handleResume(
    row
) {

    if (
        !window.confirm(
            `Resume schedule "${row.schedule_name}"?`
        )
    ) {

        return;

    }

    try {

        await wmsRecurringScheduleService.resumeSchedule(
            row.id
        );

        alert(
            "Schedule resumed successfully."
        );

        loadSchedules();

    }

    catch (err) {

        console.error(err);

        alert(
            "Failed to resume schedule."
        );

    }

}

    async function handleCancel(
    row
) {

    if (
        !window.confirm(
            `Cancel schedule "${row.schedule_name}"?\n\nThis action cannot be undone.`
        )
    ) {

        return;

    }

    try {

        await wmsRecurringScheduleService.cancelSchedule(
            row.id
        );

        alert(
            "Schedule cancelled successfully."
        );

        loadSchedules();

    }

    catch (err) {

        console.error(err);

        alert(
            "Failed to cancel schedule."
        );

    }

}

    return (

        <div className="container-fluid">

            {/* ===================================================== */}
            {/* PAGE HEADER */}
            {/* ===================================================== */}

            <div className="d-flex justify-content-between align-items-center mb-3">

                <div>

                    <h4 className="mb-1">

                        Recurring Work Schedules

                    </h4>

                    <small className="text-muted">

                        Manage recurring schedules and scheduler execution

                    </small>

                </div>

                <div className="d-flex gap-2">

                    <button
                        className="btn btn-outline-primary"
                        onClick={handleRunScheduler}
                    >

                        <i className="fas fa-sync-alt me-2" />

                        Run Scheduler

                    </button>

                    <button
                        className="btn btn-primary"
                    >

                        <i className="fas fa-plus me-2" />

                        New Schedule

                    </button>

                </div>

            </div>

            <hr />

            {/* ===================================================== */}
            {/* FILTER */}
            {/* ===================================================== */}

            <RecurringScheduleFilter

                filters={filters}

                onChange={handleFilterChange}

                onSearch={loadSchedules}

                onReset={handleReset}

            />

            {/* ===================================================== */}
            {/* TABLE */}
            {/* ===================================================== */}

            {loading ? (

                <div className="text-center p-5">

                    Loading...

                </div>

            ) : (

                <>
                    <RecurringScheduleTable
                        rows={rows}
                        onView={handleView}
                        onEdit={handleEdit}
                        onPause={handlePause}
                        onResume={handleResume}
                        onCancel={handleCancel}
                    />

                    {pagination.pages > 1 && (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "12px",
                            marginTop: "16px"
                        }}
                    >

                        <button
                            type="button"
                            disabled={pagination.page <= 1}
                            onClick={() =>
                                loadSchedules(
                                    filters,
                                    pagination.page - 1
                                )
                            }
                        >
                            Previous
                        </button>

                        <span>
                            Page {pagination.page} of {pagination.pages}
                        </span>

                        <button
                            type="button"
                            disabled={
                                pagination.page >=
                                pagination.pages
                            }
                            onClick={() =>
                                loadSchedules(
                                    filters,
                                    pagination.page + 1
                                )
                            }
                        >
                            Next
                        </button>

                    </div>
                )}
            </>
            )}

        </div>

    );

}

export default RecurringScheduleListPage;